import React from 'react';
import './InfoPage.css';
import { FaClock, FaPhoneAlt, FaCalendarCheck, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const InfoPage = () => {
	return (
		<section className="why-us">
			<div className="container">
				<div className="row g-4 align-items-stretch">
					<div className="col-lg-4">
						<div className="why-us-card">
							<span className="why-us-badge">Why choose us</span>
							<h2>Healthcare you can trust, care that puts you first</h2>
							<p>
								We combine experienced specialists, modern facilities, and a patient-centered approach. 
								From same-day appointments to 24/7 emergency support, we’re here when you need us.
							</p>
							<Link to="/about" className="why-us-cta">
								Learn more <FaChevronRight className="ms-1" />
							</Link>
						</div>
					</div>
					<div className="col-lg-8">
						<div className="row g-4 why-us-cards-row">
							<div className="col-md-4">
								<div className="info-box">
									<div className="info-box-icon">
										<FaCalendarCheck />
									</div>
									<h4>Instant Booking</h4>
									<span className="info-box-sub">Quick & easy</span>
									<p>Browse specialists by category, pick a slot that suits you and submit your request in under 2 minutes.</p>
								</div>
							</div>
							<div className="col-md-4">
								<div className="info-box">
									<div className="info-box-icon info-box-icon--emergency">
										<FaPhoneAlt />
									</div>
									<h4>Invoice & Confirmation</h4>
									<span className="info-box-sub">We handle it</span>
									<p>We coordinate with your doctor, send your invoice via email and WhatsApp, and confirm your booking once payment is received.</p>
								</div>
							</div>
							<div className="col-md-4">
								<div className="info-box">
									<div className="info-box-icon">
										<FaClock />
									</div>
									<h4>Our hours</h4>
									<span className="info-box-sub">Office schedule</span>
									<ul className="info-box-schedule">
										<li><span>Mon – Fri</span> <span>8:00 AM – 5:00 PM</span></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default InfoPage;
